// A form marked data-skip-empty-fields (the admin figures batch edit, which has hundreds of fields) disables its empty
// inputs as it's submitted, so they aren't sent and the request stays small enough to go through
document.addEventListener('submit', (e) => {
  const form = e.target
  if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-skip-empty-fields')) return
  form.querySelectorAll('input').forEach((input) => {
    if (input.value === '') input.disabled = true
  })
})
